const twoFactorAuthES = {
    "view": {
        "title": "Autenticación de Dos Factores",
        "form": {
            "label": {
                "currentMethod": "Método Actual de Dos Factores",
                "authenticatorSetupTitle": "Configura tu Aplicación de Autenticación",
                "scanInstructions": "Escanea el código QR a continuación usando cualquier aplicación de autenticación TOTP (como Authy, Google Authenticator, Microsoft Authenticator, etc.).",
                "qrCodeAlt": "Código QR para configuración del autenticador",
                "step1": "Abre tu aplicación de autenticación.",
                "step2": "Selecciona la opción para agregar una nueva cuenta.",
                "step3": "Elige la opción \"Escanear un código QR\" en la aplicación.",
                "step4": "Apunta la cámara de tu teléfono al código QR de arriba.",
                "step5": "Una vez escaneado, el autenticador comenzará a generar un código OTP de 6 dígitos que se actualiza cada 30 segundos. Este código OTP se puede usar para completar el proceso de inicio de sesión.",
                "appLinks": "Aquí están los enlaces para algunas aplicaciones de autenticación comunes:",
                "appLinksAuthy": "Authy",
                "appLinksGoogle": "Google Authenticator",
                "appLinksMicrosoft": "Microsoft Authenticator",
                "googlePlay": "Google Play Store",
                "appStore": "Apple App Store",
                "loadingQrCode": "Cargando código QR...",
                "emailSetupTitle": "Autenticación de Dos Factores por Correo Electrónico",
                "emailDescription": "Recibirás una Contraseña de Un Solo Uso (OTP) en tu dirección de correo electrónico registrada, que se puede usar para completar el proceso de inicio de sesión. Asegúrate de revisar tu bandeja de entrada de correo electrónico o carpeta de spam para el OTP al iniciar sesión."
            },
            "help_text": {
                "currentMethod": "El correo electrónico está actualmente configurado como el método predeterminado para la Autenticación de Dos Factores. Sin embargo, recomendamos usar el método de Autenticador para mayor seguridad."
            },
            "option": {
                "2faMethod": {
                    "selectMethod": "Seleccionar Método 2FA",
                    "email": "Correo Electrónico",
                    "auth": "Autenticador"
                }
            },
            "button": {
                "save": "Guardar",
                "saving": "Guardando..."
            }
        },
        "backupCodes": {
            "title": "Códigos de Respaldo",
            "view": {
                "button": {
                    "generate": "Generar Códigos de Respaldo",
                    "download": "Descargar Códigos de Respaldo"
                },
                "modal": {
                    "header": "Tus Códigos de Respaldo",
                    "body": {
                        "noCodes": "No hay códigos de respaldo disponibles"
                    }
                }
            }
        }
    }
};

export default twoFactorAuthES;